import { MainLayout, Spinner } from '@/components';
import { NotFound } from '@/pages';
import { lazyImport } from '@/utils';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

const { DiagnosisRoutes } = lazyImport(() => import('@/pages/diagnosis'), 'DiagnosisRoutes')

export function Protected() {
  function Protected() {
    return (
      <MainLayout>
        <Suspense fallback={<Spinner />}>
          <Outlet />
        </Suspense>
      </MainLayout>
    );
  }

  const ProtectedRoutes = [
    {
      path: '/diagnosis/*',
      element: <Protected />,
      children: [
        {
          path: '',
          element: <DiagnosisRoutes />
        },
      ]
    },
    {
      path: '*',
      element: <Protected />,
      children: [
        {
          path: '',
          element: <NotFound />,
        },
      ],
    },
  ];

  return { ProtectedRoutes };
}
